import { FC, useCallback, useEffect } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { useRouter } from 'next/router';
import { DTOSubscriptionBenefitItem } from 'src/apis/dto/DTOSubscription';
import SubscriptionSuccessModal from 'src/components/AzarOnly/Subscription/SubscriptionSuccessModal';
import { useSubscriptionCheckoutSuccess } from 'src/hooks/useSubscription';
import { Routes } from 'src/router/route';
import { showModalAtom } from 'src/stores/modal/atoms';
import { checkoutSubscriptionIdAtom } from 'src/stores/subscription/atoms';
import { showCommonErrorToastAtom } from 'src/stores/toast/atoms';
import { ModalType } from 'src/types/Modal';
const SubscriptionRedirectView: FC = () => {
  const router = useRouter();
  const showModal = useSetAtom(showModalAtom);
  const showCommonErrorToast = useSetAtom(showCommonErrorToastAtom);
  const [checkoutSubscriptionId, setCheckoutSubscriptionId] = useAtom(checkoutSubscriptionIdAtom);

  // url로 직접 들어오면 subscriptionId가 없으므로 홈으로 리다이렉트
  // subscriptionId가 있으면 polling 성공시에 subscription이 null로 변경되기때문에 deps에서 제거
  useEffect(() => {
    if (!checkoutSubscriptionId) {
      router.replace(Routes['/']());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router]);
  const handleSuccess = useCallback((benefits: DTOSubscriptionBenefitItem[]) => {
    router.replace(Routes['/']()).then(() => {
      setCheckoutSubscriptionId(null);
      showModal({
        key: ModalType.SUBSCRIPTION_SUCCESS,
        component: () => <SubscriptionSuccessModal benefits={benefits} />
      });
    });
  }, [showModal, router, setCheckoutSubscriptionId]);
  const handleError = useCallback(() => {
    setCheckoutSubscriptionId(null);
    showCommonErrorToast();
    router.replace(Routes['/']());
  }, [showCommonErrorToast, router, setCheckoutSubscriptionId]);
  useSubscriptionCheckoutSuccess(checkoutSubscriptionId, handleSuccess, handleError);
  return null;
};
export default SubscriptionRedirectView;